import { ReactNode } from 'react'
import { VARIANT } from "@/src/utils/buildUtils"
import { featureConfig, Features } from "@/src/utils/featureConfig"

type FeatureRendererProps = {
    children: ReactNode | ReactNode[] | null
    type: keyof Features
}

const FeatureRenderer = (props: FeatureRendererProps) => {
    const { children, type } = props
    const selectedconfig = featureConfig[VARIANT]
    return selectedconfig?.[type] ? <>{children}</> : <></>
}

export default FeatureRenderer